import React from 'react';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 bg-white" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center mb-12" data-id="element-204">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-205">
            ❌ ¿Te suena familiar?
          </h2>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-206">
          <div className="bg-red-50 rounded-xl p-6 mb-10" data-id="element-207">
            <ul className="space-y-4" data-id="element-208">
              <li className="flex items-start" data-id="element-209">
                <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-210" />
                <p className="text-gray-700" data-id="element-211">
                  Te levantas cansado, aunque hayas dormido.
                </p>
              </li>
              <li className="flex items-start" data-id="element-212">
                <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-213" />
                <p className="text-gray-700" data-id="element-214">
                  Tu mente da vueltas cuando solo quieres descansar.
                </p>
              </li>
              <li className="flex items-start" data-id="element-215">
                <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-216" />
                <p className="text-gray-700" data-id="element-217">
                  Intentas enfocarte, pero la ansiedad te arrastra.
                </p>
              </li>
              <li className="flex items-start" data-id="element-218">
                <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-219" />
                <p className="text-gray-700" data-id="element-220">
                  Los problemas del trabajo, la familia o el dinero se acumulan.
                </p>
              </li>
              <li className="flex items-start" data-id="element-221">
                <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-222" />
                <p className="text-gray-700" data-id="element-223">
                  Y justo cuando más necesitas tranquilidad… es cuando menos la
                  encuentras.
                </p>
              </li>
            </ul>
          </div>
          <div className="text-center mb-12" data-id="element-224">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-225">
              👉 No es tu culpa.
            </h3>
            <p className="text-gray-600" data-id="element-226">
              Vivimos en una era de ruido constante, exceso de responsabilidades
              y presión diaria. Lo que estás sintiendo… es la respuesta normal a
              un entorno que no lo es.
            </p>
          </div>
          <div className="mb-12" data-id="element-227">
            <h3 className="text-xl font-semibold text-center mb-6 text-gray-900" data-id="element-228">
              🚫 Lo que ya probaste (y por qué no funciona)
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-229">
              <div className="bg-gray-50 p-5 rounded-lg" data-id="element-230">
                <div className="flex items-start mb-3" data-id="element-231">
                  <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-232" />
                  <p className="font-medium text-gray-800" data-id="element-233">
                    Café para "aguantar el día"
                  </p>
                </div>
                <p className="text-gray-600 text-sm" data-id="element-234">
                  → te activa, pero luego dispara tu ansiedad.
                </p>
              </div>
              <div className="bg-gray-50 p-5 rounded-lg" data-id="element-235">
                <div className="flex items-start mb-3" data-id="element-236">
                  <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-237" />
                  <p className="font-medium text-gray-800" data-id="element-238">
                    Pastillas para dormir
                  </p>
                </div>
                <p className="text-gray-600 text-sm" data-id="element-239">
                  → calman un rato, pero no resuelven la raíz.
                </p>
              </div>
              <div className="bg-gray-50 p-5 rounded-lg" data-id="element-240">
                <div className="flex items-start mb-3" data-id="element-241">
                  <XIcon className="h-5 w-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-242" />
                  <p className="font-medium text-gray-800" data-id="element-243">
                    Videos de relajación
                  </p>
                </div>
                <p className="text-gray-600 text-sm" data-id="element-244">
                  → nunca los terminas porque justo cuando necesitas calma, no
                  tienes tiempo.
                </p>
              </div>
            </div>
            <p className="text-center mt-6 text-gray-700" data-id="element-245">
              Todos son parches temporales. Pero tú necesitas una herramienta
              real.
            </p>
          </div>
        </div>
      </div>
    </section>;
}